export const SliderProjects = [
    {
        year: '2017/2018',
        projectCount: 12,
        project1: [{
            projectName: 'Debaty Naukowe w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1166'
        }],
        project2: [{
            projectName: 'Opowiem Wam o Łemkach',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=699'
        }],
        project3: [{
            projectName: 'Nauka programowania w praktyce',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=89'
        }],
        project4: [{
            projectName: 'Nowy Sącz – smart city II edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=93'
        }],
        project5: [{
            projectName: 'Program stypendialny „Młode Talenty” II tura 2017',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=95'
        }],
        project6: [{
            projectName: 'Program stypendialny Młode Talenty I tura 2018 roku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=113'
        }],
        project7: [{
            projectName: 'Prymusi Elektryka – po raz pierwszy!',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=97'
        }],
        project8: [{
            projectName: 'SOS dla Sądecczyzny VIII edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=99'
        }],
        project9: [{
            projectName: 'VII Piknik Naukowy w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=101'
        }],
        project10: [{
            projectName: 'Wolontariat uczniowski z matematyki i przedmiotów zawodowych',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=105'
        }],
        project11: [{
            projectName: 'Własna firma – pomysł na życie – IV edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=107'
        }],
        project12: [{
            projectName: 'X Memoriał Jana Borka Międzyszkolny Turniej Szachowy Sądecczyzny',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=109'
        }]
    },
    {
        year: '2018/2019',
        projectCount: 9,
        project1: [{
            projectName: 'Pszczoły zagościły w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1418'
        }],
        project2: [{
            projectName: 'Nowy Sącz – smart city III edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1409'
        }],
        project3: [{
            projectName: 'VIII Piknik Naukowy w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1274'
        }],
        project4: [{
            projectName: 'Nauka programowania w praktyce',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1235'
        }],
        project5: [{
            projectName: 'Debaty Naukowe w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1166'
        }],
        project6: [{
            projectName: 'XI Memoriał Jana Borka',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1245'
        }],
        project7: [{
            projectName: 'Program stypendialny „Młode talenty”',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1247'
        }],
        project8: [{
            projectName: 'SOS dla Sądecczyzny IX edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1249'
        }],
        project9: [{
            projectName: 'Konkurs „interface multimedia unit”',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1296'
        }],
        project10: null,
        project11: null,
        project12: null
    },
    {
        year: '2019/2020',
        projectCount: 8,
        project1: [{
            projectName: 'IX Piknik Naukowy w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1950'
        }],
        project2: [{
            projectName: 'Nauka programowania w praktyce',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1674'
        }],
        project3: [{
            projectName: 'Coding Night w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1676'
        }],
        project4: [{
            projectName: 'Debaty naukowe w Elektryku',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1678'
        }],
        project5: [{
            projectName: 'XII Memoriał Jana Borka',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1680'
        }],
        project6: [{
            projectName: 'Spotkania z kulturą w Elektryku ',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1682'
        }],
        project7: [{
            projectName: 'Wycieczki rowerowe ze Starego Sącza',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1727'
        }],
        project8: [{
            projectName: 'Pszczoły zagościły w Elektryku – edycja II',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1757'
        }],
        project9: null,
        project10: null,
        project11: null,
        project12: null
    },
    {
        year: '2020/2021',
        projectCount: 3,
        project1: [{
            projectName: 'Coding Night w Elektryku II edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1969'
        }],
        project2: [{
            projectName: 'W Elektryku uczymy zasad właściwego kompostowania ',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=1989'
        }],
        project3: [{
            projectName: 'Nie – bo nie mam czasu – V edycja',
            projectLink: 'http://stowarzyszenie.zsem.edu.pl/?page_id=2021'
        }],
        project4: null,
        project5: null,
        project6: null,
        project7: null,
        project8: null,
        project9: null,
        project10: null,
        project11: null,
        project12: null
    }
]